export enum ActionType {
  GET_INBOUND_LIST = 'get_inbound_list',
  GET_INBOUND_LIST_SUCCESS = 'get_inbound_list_success',
  GET_INBOUND_LIST_ERROR = 'get_inbound_list_error',

  GET_INBOUND_DETAIL = 'get_inbound_detail',
  GET_INBOUND_DETAIL_SUCCESS = 'get_inbound_detail_success',
  GET_INBOUND_DETAIL_ERROR = 'get_inbound_detail_error',

  SHOW_MODAL = 'show_modal',
  APPROVE_INBOUND = 'approve_inbound',
  APPROVE_INBOUND_SUCCESS = 'approve_inbound_success',
  APPROVE_INBOUND_ERROR = 'approve_inbound_error',

  POST_COMPLETE = 'post_complete',
  POST_COMPLETE_SUCCESS = 'post_complete_success',
  POST_COMPLETE_ERROR = 'post_complete_error',
  // INVENTORY
  GET_TYPE_LOGIN = 'get_type_login',
  GET_ID_SELLER = 'get_id_seller',
  GET_USER_EMAIL = 'get_user_email',

  // RETURN/ DISPOSAL
  GET_RETURN_DISPOSAL_LIST = 'get_return_disposal_list',
  GET_RETURN_DISPOSAL_LIST_SUCCESS = 'get_return_disposal_list_success',
  GET_RETURN_DISPOSAL_LIST_ERROR = 'get_return_disposal_list_error',

  GET_RETURN_DISPOSAL_DETAIL = 'get_return_disposal_detail',
  GET_RETURN_DISPOSAL_DETAIL_SUCCESS = 'get_return_disposal_detail_success',
  GET_RETURN_DISPOSAL_DETAIL_ERROR = 'get_return_disposal_detail_error',

  PUT_RETURN_DISPOSAL_SAVE = 'get_return_disposal_save',
  PUT_RETURN_DISPOSAL_SAVE_SUCCESS = 'get_return_disposal_save_success',
  PUT_RETURN_DISPOSAL_SAVE_ERROR = 'get_return_disposal_save_error',

  //MY ACCOUNT

  GET_INFORMATION_ACCOUNT = 'get_information_account',

  // Settlement
  GET_SETTLEMENT_LIST = 'get_settlement_list',
  GET_SETTLEMENT_LIST_SUCCESS = 'get_settlement_list_success',
  GET_SETTLEMENT_LIST_ERROR = 'get_settlement_list_error',

  GET_AMOUNT_INFO = 'get_amount_info',
  GET_AMOUNT_INFO_SUCCESS = 'get_amount_info_success',
  GET_AMOUNT_INFO_ERROR = 'get_amount_info_error',

  GET_BILLING_INQUIRY_DETAIL = 'get_billing_inquery_detail',
  GET_BILLING_INQUIRY_DETAIL_SUCCESS = 'get_billing_inquery_detail_success',
  GET_BILLING_INQUIRY_DETAIL_ERROR = 'get_billing_inquery_detail_error',

  GET_CUSTOMER_INFO = 'get_customer_info',
  GET_CUSTOMER_INFO_SUCCESS = 'get_customer_info_success',
  GET_CUSTOMER_INFO_ERROR = 'get_customer_info_error',

  GET_INQUIRY_INBOUND_INFO = 'get_inquiry_inbound_info',
  GET_INQUIRY_INBOUND_INFO_SUCCESS = 'get_inquiry_inbound_info_success',
  GET_INQUIRY_INBOUND_INFO_ERROR = 'get_inquiry_inbound_info_error',

  POST_BILLING_INQUIRY = 'post_billing_inquiry',
  POST_BILLING_INQUIRY_SUCCESS = 'post_billing_inquiry_success',
  POST_BILLING_INQUIRY_ERROR = 'post_billing_inquiry_error'
}
